export default {"src":"/_next/static/media/icn-search.240fc061.svg","height":20,"width":20};